import { Component, Input, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { startsWith as _startsWith } from 'lodash';

import { SearchResult } from '../../+state/service-locator/service-locator.models';
import { ImageService } from '../../services/image.service';

@Component({
  selector: 'drp-shop-card',
  templateUrl: './shop-card.component.html',
  styleUrls: ['./shop-card.component.scss'],
  standalone: false
})
export class ShopCardComponent implements OnInit {
  @Input() shop: SearchResult;
  @Input() isPartner: boolean;
  @Input() index: any;
  formattedUrl: any;
  starImage: SafeResourceUrl;
  constructor(private images: ImageService) {}

  ngOnInit() {
    this.starImage = this.images.getStarImage();
    this.formattedUrl =
      this.shop.contactMethodDetail.websiteAddresses.length > 0
        ? this.formatWebisteUrl(this.shop.contactMethodDetail.websiteAddresses[0])
        : '';
  }

  formatWebisteUrl(url: string) {
    const http = 'http://';
    return !_startsWith(url, http) ? http.concat(url) : url;
  }
}
